import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { SeatConfigurationResponse } from '~client/model/admin/seat-configuration-response';
import { LocationProfileResponse } from '~client/model/location-profile-response';
import { SeatConfigurationRequest } from '~client/model/admin/seat-configuration-request';

/* Yoop Admin and Client User APIs for creating and maintaining Venues and Event Locations */
export class LocationProfileAdminController extends BaseController {
  /* Gets a list of event or venue locations */
  public getListOfLocations$(): Observable<LocationProfileResponse[]> {
    return this.get$('/location/profile/list');
  }

  /* Gets a list of event or venue locations */
  public getListOfSeatConfigurations$(
    locationProfileId: number,
  ): Observable<SeatConfigurationResponse[]> {
    return this.get$('/location/seatConfiguration/list', { locationProfileId });
  }

  public createSeatConfiguration$(
    request: SeatConfigurationRequest,
  ): Observable<SeatConfigurationResponse> {
    return this.post$('/location/seatConfiguration', request);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/controller/location-profile-admin-controller.ts